import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface DownloadInvoice {
	uriParams: Api.Operations['downloadInvoice']['parameters']['path']
	response: Api.Operations['downloadInvoice']['responses']['200']
}

export const downloadInvoice = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<DownloadInvoice>(
		{
			method: 'get',
			url: '/invoices/download/{invoiceRef}',
			...overideConfig,
		},
		axiosInstance,
	)
